import React from 'react';
import type { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { fireOnce } from '@/lib/fireOnce';
import analytics from '@/services/analytics';
import { CmsMenuItem } from '@/services/cms/models/CmsNavigationItem';
import { CmsSiteConfig } from '@/services/cms/models/CmsSiteConfig';
import { LargeMenu } from './components/LargeMenu/LargeMenu';
import { SmallMenu } from './components/SmallMenu/SmallMenu';

export interface SiteAppBarMenuProps {
    menuItems?: CmsMenuItem[];
    container?: HTMLElement;
    siteConfig: CmsSiteConfig;
    sx?: SxProps<Theme>;
}

export const SiteAppBarMenu = ({ container, menuItems, siteConfig, sx }: SiteAppBarMenuProps) => (
    <Box
        onMouseOver={() => {
            const location = window.location.toString();
            fireOnce(
                `nav-engagement-${location}`,
                () => {
                    analytics.track('nav_engagement', {
                        engagement_type: 'mouse hovers',
                        location,
                    });
                },
                'session'
            );
        }}
        sx={sx}
    >
        <SmallMenu items={menuItems || []} siteConfig={siteConfig} /> <LargeMenu items={menuItems || []} container={container} />
    </Box>
);
